<script>
export default {
  data() {
    return {
      items: [
        {
          name: 'admin-contract-catalog',
          title: this.$t('contract_nav.contract_catalog'),
        },
        {
          name: 'admin-contract-agreement-list',
          title: this.$t('contract_nav.contract_agreement_list'),
        },
      ],
    }
  },
}
</script>

<template>
  <ul :class="$style.localNavigation">
    <router-link
      v-for="{ name, title } in items"
      :key="name"
      :to="{ name, params: $route.params }"
      :active-class="$style.on"
      tag="li"
    >
      <a href="#" @click.prevent>{{ title }}</a>
    </router-link>
  </ul>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
</style>
+
